export default __webpack_public_path__ + "static/media/CHICAGO_FIRE.8b45c8a0.gif";